// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"747":"731dbdf6","935":"731dbdf6","1701":"731dbdf6"}[chunkId] + ".chunk.css";
};